// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"f5039f7c","125":"a8d17f3d","228":"9a8d47dc","272":"8ec62dfe","287":"4327bee9","352":"c0f7f7c8","549":"754ac649","666":"b2c655b9","816":"6db384f6","837":"f5efd230","930":"2dadf3ab"}[chunkId] + ".chunk.js";
};